<template>
<div v-html="text"></div>
</template>

<script>
export default {

  name: 'PlannerTableTextCellBody',
  props:["data"],
  data () {
    return {

    }
  },
  computed:{
  	text()
  	{
  		if(this.data)
  		{
  			let text = this.data.replaceAll(/\r?\n/g, '<br />');
  			return text
  		}
  		
  		
  	}
  }
}
</script>

<style lang="css" scoped>
</style>